const getters = {
	isLogin: state => state.app.isLogin,
	StoreVersion: state => state.app.StoreVersion,
	virtual_host: state => state.app.virtual_host,
	StoreIsKnowledge: state => state.app.StoreIsKnowledge,
	sidebar: state => state.app.sidebar,
	language: state => state.app.language,
	size: state => state.app.size,
	device: state => state.app.device,
	subBrandList: state => state.app.subBrandList,
	channelList: state => state.app.channelList,
	skillGroupLists: state => state.app.skillGroupLists,
	visitedViews: state => state.tagsView.visitedViews,
	cachedViews: state => state.tagsView.cachedViews,
	token: state => state.user.token,
	// s_token: state => state.user.s_token,
	agentId: state => state.user.agentId,
	avatar: state => state.user.avatar,
	name: state => state.user.name,
	introduction: state => state.user.introduction,
	roles: state => state.user.roles,
	userInfo: state => state.user.userInfo,
	lark_switch_url: state => state.user.lark_switch_url,
	permission_menus: state => state.permission.menus,
	permission_routes: state => state.permission.routes,
	errorLogs: state => state.errorLog.logs,
	// 消息未读数总计
	unreadChatNum: state => {
	  return state.imChatService.items.reduce((total, item) => {
	    return total + parseInt(item.unread_num)
	  }, 0)
	},
	// IM渠道列表
	imChannelList:state => state.imChatService.channle_list,
	
	serviceStatus:state => state.user.serviceStatus,
	StoreIsHideContainer: state => state.telService.StoreIsHideContainer,
	StoreSoftPhoneInMsg: state => state.telService.StoreSoftPhoneInMsg,
	StoreAgentInfo: state => state.telService.StoreAgentInfo,
	StoreSingInCategory: state => state.telService.StoreSingInCategory,
	StoreIsSignIn: state => state.telService.StoreIsSignIn,
	StoreIsIdle: state => state.telService.StoreIsIdle,
	StoreIsBusy: state => state.telService.StoreIsBusy,
	StoreIsBusyReason: state => state.telService.StoreIsBusyReason,
	StoreIsCall: state => state.telService.StoreIsCall,
	StoreIsCallCurrentInfo: state => state.telService.StoreIsCallCurrentInfo,
	StoreIsAnswer: state => state.telService.StoreIsAnswer,
	StoreIsKeep: state => state.telService.StoreIsKeep,
	StoreIsMonitor: state => state.telService.StoreIsMonitor,
	StoreCallTime: state => state.telService.StoreCallTime,
	StoreIsBusyReasonList: state => state.telService.StoreIsBusyReasonList,
	StoreTelRoles: state => state.telService.StoreTelRoles,
	StoreSessionList: state => state.knowService.StoreSessionList,
	StoreHistoryList: state => state.knowService.StoreHistoryList,
	StoreSessionCurrentNode: state => state.knowService.StoreSessionCurrentNode,
	StoreMessageCount: state => state.knowService.StoreMessageCount,
	StoreImageView: state => state.knowService.StoreImageView,
	StoreIsImageView: state => state.knowService.StoreIsImageView,
	StoreTuId: state => state.telService.StoreTuId,
	StoreCallout: state => state.telService.StoreCallout,
	StoreAuxList: state => state.telService.StoreAuxList,
	
	needCreateSubBrand: state => state.user.needCreateSubBrand,
	isShowPhone: state => state.app.isShowPhone,
}
export default getters